"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = void 0;
class Pagination {
    constructor() {
        this.from = 0;
        this.size = 100;
    }
    static default() {
        return { from: 0, size: 100 };
    }
}
exports.Pagination = Pagination;
//# sourceMappingURL=interface.js.map